import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    FaClock,
    FaFire,
    FaCheck,
    FaUsers,
    FaBox,
    FaBan,
} from 'react-icons/fa';

const StatCard = ({
    Icon,
    label,
    value,
    cardHover,
    iconBg,
    iconColor,
    onClick,
}) => (
    <div
        onClick={onClick}
        className={`
            bg-white border border-gray-100 rounded-lg p-2.5
            flex items-center gap-2.5
            hover:shadow-sm
            active:scale-95
            transition-all duration-150
            hover:-translate-y-1
            ${onClick ? "cursor-pointer" : ""}
            ${onClick ? cardHover : "hover:border-gray-200"}
        `}
    >
        <div className={`w-9 h-9 rounded-md flex items-center justify-center flex-shrink-0 ${iconBg}`}>
            <Icon className={`text-base ${iconColor}`} />
        </div>

        <div className="min-w-0">
            <div className="text-[10px] xl:text-xs uppercase tracking-wide text-gray-500 font-medium leading-tight truncate">
                {label}
            </div>

            <div className="text-lg xl:text-xl font-semibold text-gray-900 leading-tight">
                {value}
            </div>
        </div>
    </div>
);

const Info = ({ info, selectedOutlet }) => {
    const {
        completedToday,
        cooking,
        itemsCompetedToday,
        started,
        totalOrdersToday,
        voidTotalToday,
    } = info;

    const type = localStorage.getItem("type");
    const navigate = useNavigate();

    const handleVoidNavigate = () => {
        if (selectedOutlet) {
            if (type === "kitchen") {
                window.open('/void-today', '_blank', 'noopener,noreferrer');
            } else {
                navigate('/void-today', { state: { outlet: selectedOutlet } });
            }
        }
    };

    const handleCompleteNavigate = () => {
        if (selectedOutlet) {
            if (type === "kitchen") {
                window.open('/completed-today', '_blank', 'noopener,noreferrer');
            } else {
                navigate('/completed-today', { state: { outlet: selectedOutlet } });
            }
        }
    };

    const cards = [
        {
            label: 'Not Seen',
            value: started ?? 0,
            Icon: FaClock,
            iconBg: 'bg-amber-50',
            iconColor: 'text-amber-500',
        },
        {
            label: 'Active',
            value: cooking ?? 0,
            Icon: FaFire,
            iconBg: 'bg-blue-50',
            iconColor: 'text-blue-500',
        },
        {
            label: 'Completed',
            value: completedToday ?? 0,
            cardHover: 'hover:!border-green-200 transition-all duration-150',
            Icon: FaCheck,
            iconBg: 'bg-green-50',
            iconColor: 'text-green-600',
            onClick: handleCompleteNavigate,
        },
        {
            label: 'Total Today',
            value: totalOrdersToday ?? 0,
            Icon: FaUsers,
            iconBg: 'bg-violet-50',
            iconColor: 'text-violet-600',
        },
        {
            label: 'Items Prepared',
            value: itemsCompetedToday ?? 0,
            Icon: FaBox,
            iconBg: 'bg-gray-100',
            iconColor: 'text-gray-500',
        },
    ];

    return (
        <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 gap-2 mb-3">
            {cards.map((card, index) => (
                <StatCard key={index} {...card} />
            ))}

            <button
                onClick={handleVoidNavigate}
                className="
                    bg-white border border-red-100 rounded-lg p-2.5
                    flex items-center gap-2.5
                    hover:!border-red-200
                    hover:!shadow-sm
                    active:scale-95
                    transition-all duration-150
                    text-left w-full
                    hover:-translate-y-1
                "
            >
                <div className="w-9 h-9 rounded-md bg-red-50 flex items-center justify-center flex-shrink-0">
                    <FaBan className="text-base text-red-500" />
                </div>
                <div className="min-w-0">
                    <div className="text-[10px] xl:text-xs uppercase tracking-wide text-red-400 font-medium leading-tight truncate">
                        Void Today
                    </div>
                    <div className="text-lg xl:text-xl font-semibold text-red-600 leading-tight">
                        {voidTotalToday ?? 0}
                    </div>
                </div>
            </button>
        </div>
    );
};

export default Info;